import {Module} from 'module/Module'
import {ClipboardReducerNS} from 'module/Clipboard/reducer/ClipboardReducer'
import {ClipboardEpic} from 'module/Clipboard/epic/ClipboardEpic'

export const ClipboardModule: Module = {
	reducerNS: {...ClipboardReducerNS},
	epics: [ClipboardEpic],
	properties: [],
}